"use strict";

var _check_private_redeclaration = require("./_check_private_redeclaration.cjs");

function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration._(obj, privateMap);
    privateMap.set(obj, value);
}
exports._ = _class_private_field_init;
